import { render, staticRenderFns } from "./NewVerifyOTPComponent.vue?vue&type=template&id=c75cc522&scoped=true"
import script from "./NewVerifyOTPComponent.vue?vue&type=script&lang=js"
export * from "./NewVerifyOTPComponent.vue?vue&type=script&lang=js"
import style0 from "./NewVerifyOTPComponent.vue?vue&type=style&index=0&id=c75cc522&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c75cc522",
  null
  
)

export default component.exports